import {useAsyncState} from 'hooks/useAsyncState';
import ApiService from 'api/ApiService';
import React from 'react';
import {useHandleApiError} from './useHandleApiError';
// import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

export type CallbackOptions<ResponseType> = {
   onSuccess?: (data: ResponseType) => void;
   /**
    *
    * @param error
    * @param message
    * @param errResp
    * @returns return boolean if handled and hide toast
    */
   onFailure?: (error: any, message: string, errResp: Response) => void | boolean;
};

type ApiOptions<ResponseType> = CallbackOptions<ResponseType> & {
   persistState?: boolean;
   hideToast?: boolean;
};

export type RequestOptions<ResponseType> = CallbackOptions<ResponseType> & {
   urlParams?: string;
   searchParams?: Record<string, string>;
   // helpers?: FormOnSubmitHelpers<any>;
};

export function usePostApi<ResponseType = any>(url: string, options?: ApiOptions<ResponseType>) {
   const {state, loading, error, setState, setLoading, setError} = useAsyncState<ResponseType>();

   const handleError = useHandleApiError({
      url,
      setError,
      setLoading,
      hideToast: options?.hideToast,
   });

   const request = React.useCallback(
      (body: BodyInit | null, requestOptions?: RequestOptions<ResponseType>) => {
         let _url = url;
         if (requestOptions?.urlParams) {
            _url = url + requestOptions.urlParams;
         }
         if (requestOptions?.searchParams) {
            _url = `${_url}?${new URLSearchParams(requestOptions?.searchParams)}`;
         }
         setLoading(true);
         !options?.persistState && setState(undefined);
         return ApiService.postSecureJson(_url, body)
            .then((res) => {
               return res.json().catch(() => res);
            })
            .then((data: ResponseType) => {
               setState(data);
               setLoading(false);
               options?.onSuccess?.(data);
               requestOptions?.onSuccess?.(data);
               return data;
            })
            .catch(handleError(options?.onFailure || requestOptions?.onFailure))
            .finally(() => {
               // requestOptions?.helpers?.setSubmitting(false);
            });
      },
      [handleError, options, setLoading, setState, url]
   );
   return {request, state, loading, error};
}
